import React, { useState, useEffect, useCallback } from 'react';

/**
 * Обёртка для экранов с критическими данными (PIN, пароль, OTP).
 * - Затрудняет выделение и копирование (user-select, onCopy/onCut).
 * - При уходе с экрана (visibility hidden) показывает overlay, чтобы контент не попал в превью/скриншот.
 * Полная блокировка скриншотов в WebView Telegram со стороны приложения недоступна.
 */
const SensitiveContent = ({ children, className = '', showWarning = false, warningText = 'Не передавайте код третьим лицам и не делайте скриншоты.' }) => {
    const [isPageHidden, setIsPageHidden] = useState(() => typeof document !== 'undefined' && document.visibilityState === 'hidden');

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsPageHidden(document.visibilityState === 'hidden');
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, []);

    const preventCopy = useCallback((e) => {
        e.preventDefault();
    }, []);

    return (
        <div
            className={`sensitive-content relative min-h-screen ${className}`}
            style={{
                WebkitUserSelect: 'none',
                userSelect: 'none',
                WebkitTouchCallout: 'none',
            }}
            onCopy={preventCopy}
            onCut={preventCopy}
        >
            {children}
            {showWarning && (
                <p className="text-center text-xs text-gray-500 mt-3 px-2" aria-live="polite">
                    {warningText}
                </p>
            )}
            {isPageHidden && (
                <div
                    className="sensitive-content-overlay"
                    aria-hidden="true"
                >
                    <span>Вернитесь в приложение</span>
                </div>
            )}
        </div>
    );
};

export default SensitiveContent;
